'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * React hook detecting if browser window is available.
 *
 * @returns boolean
 */ const useIsBrowser = ()=>{
    return typeof window !== 'undefined';
};

exports.useIsBrowser = useIsBrowser;
//# sourceMappingURL=use-is-browser.js.map
